import { useRef, useState } from 'react';

// Drags a floating panel by its header: spread `handlers` on the header element.
// Presses on a <button> inside the header are left alone so close/minimise still click.
export const useDraggable = (initialPosition, { clamp, disabled = false } = {}) => {
  const [position, setPosition] = useState(initialPosition);
  const [isDragging, setIsDragging] = useState(false);
  const offsetRef = useRef(null);

  const onPointerDown = (e) => {
    if (disabled || e.target.closest('button')) return;
    offsetRef.current = { x: e.clientX - position.x, y: e.clientY - position.y };
    setIsDragging(true);
    e.currentTarget.setPointerCapture(e.pointerId);
  };

  const onPointerMove = (e) => {
    if (!offsetRef.current) return;
    const next = { x: e.clientX - offsetRef.current.x, y: e.clientY - offsetRef.current.y };
    setPosition(clamp ? clamp(next) : next);
  };

  // pointercancel too: a touch scroll or alt-tab mid-drag would otherwise leave the panel stuck to the cursor.
  const endDrag = (e) => {
    if (!offsetRef.current) return;
    offsetRef.current = null;
    setIsDragging(false);
    try {
      e.currentTarget.releasePointerCapture(e.pointerId);
    } catch (_) { }
  };

  return {
    position,
    isDragging,
    handlers: { onPointerDown, onPointerMove, onPointerUp: endDrag, onPointerCancel: endDrag },
  };
};
